<h1 mat-dialog-title>
  Oh no, you have no access to the <br>{{ organizationName }} group!
</h1>

<div mat-dialog-content class="pt-4 pb-6">
  <div class="text-14" *ngIf="ip">
    You must be within the {{ organizationName }} network to access this group account. <a [href]="'mailto:' + supportEmail">Contact us</a> if you have any questions regarding your group account.
  </div>

  <div class="text-14" *ngIf="email">
    You must be within the {{ organizationName }} network to access this group account. <a [href]="'mailto:' + supportEmail">Contact us</a> if you have any questions regarding your group account.
  </div>
</div>

<div mat-dialog-actions class="pt-2">
  <button app-button buttonTheme="light" buttonType="outline" (click)="handleDontShowClick()">Don't show me this again</button>
  <button app-button buttonType="primary" [mat-dialog-close]="true" cdkFocusInitial>Close</button>
</div>